import Splide from '@splidejs/splide'

document.addEventListener('DOMContentLoaded', function() {
  if (document.querySelector('#js-templates-hero-slider')) {
    const templateCarousel = new Splide('#js-templates-hero-slider', {
      type: 'fade',
      mediaQuery: 'min',
      rewind: true,
      classes: {
        arrows: 'splide__arrows templates-hero__arrows',
        pagination: 'splide__pagination templates-hero__pagination',
      },
      arrowPath: 'M15.1936 9.36019C16.0072 8.5466 17.3263 8.5466 18.1398 9.36019L28.1398 19.3602C28.9534 20.1738 28.9534 21.4929 28.1398 22.3065L18.1398 32.3065C17.3263 33.1201 16.0072 33.1201 15.1936 32.3065C14.38 31.4929 14.38 30.1738 15.1936 29.3602L23.7204 20.8333L15.1936 12.3065C14.38 11.4929 14.38 10.1738 15.1936 9.36019Z',
      i18n: {
        first: '最初のスライドに移動する',
        last: '最後のスライドに移動する',
        slideX: 'スライド%sに移動する',
        play: 'スライダーを再生する',
        prev: '前のスライドに移動する',
        carousel: 'スライダー',
        next: '次のスライドに移動する',
        select: '表示するスライドを選択する',
        slideLabel: '%s枚目（%s枚中）',
      },
    })

    templateCarousel.mount()
  }
})
